/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointDto } from './DataPointDto';
import {
    DataPointDtoFromJSON,
    DataPointDtoFromJSONTyped,
    DataPointDtoToJSON,
    DataPointDtoToJSONTyped,
} from './DataPointDto';

/**
 * A data series within a chart (e.g., a year's data)
 * @export
 * @interface ChartSeriesDto
 */
export interface ChartSeriesDto {
    /**
     * Unique identifier for this series
     * @type {string}
     * @memberof ChartSeriesDto
     */
    id: string;
    /**
     * Display label for this series (shown in legend)
     * @type {string}
     * @memberof ChartSeriesDto
     */
    label: string;
    /**
     * Array of data points for this series
     * @type {Array<DataPointDto>}
     * @memberof ChartSeriesDto
     */
    data: Array<DataPointDto>;
    /**
     * Color for this series (hex format)
     * @type {string}
     * @memberof ChartSeriesDto
     */
    color: string;
    /**
     * Order in which this series should be displayed
     * @type {number}
     * @memberof ChartSeriesDto
     */
    order?: number;
}

/**
 * Check if a given object implements the ChartSeriesDto interface.
 */
export function instanceOfChartSeriesDto(value: object): value is ChartSeriesDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function ChartSeriesDtoFromJSON(json: any): ChartSeriesDto {
    return ChartSeriesDtoFromJSONTyped(json, false);
}

export function ChartSeriesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartSeriesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'data': ((json['data'] as Array<any>).map(DataPointDtoFromJSON)),
        'color': json['color'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function ChartSeriesDtoToJSON(json: any): ChartSeriesDto {
    return ChartSeriesDtoToJSONTyped(json, false);
}

export function ChartSeriesDtoToJSONTyped(value?: ChartSeriesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'data': ((value['data'] as Array<any>).map(DataPointDtoToJSON)),
        'color': value['color'],
        'order': value['order'],
    };
}

